import { useMemo, useState } from 'react';
import { motion } from 'framer-motion';
import data from '../sample/data';
import { useCallback } from 'react';

function ProjectsPage() {
  const [filter, setFilter] = useState('all');
  const projects = data.projects;
  const filtered = useMemo(() =>
    filter === 'all' ? projects : projects.filter(p => p.stack.includes(filter)),
  [filter, projects]);

  const stacks = ['all', 'react', 'php', 'concept'];
  const [active, setActive] = useState(null);
  const open = useCallback((p) => setActive(p), []);
  const close = useCallback(() => setActive(null), []);

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-semibold">Projects</h2>
      <div className="flex flex-wrap gap-2">
        {stacks.map(s => (
          <button
            key={s}
            onClick={() => setFilter(s)}
            className={`px-3 py-1.5 rounded-full border ${filter===s? 'bg-primary text-white border-transparent':'border-slate-300 dark:border-white/10 hover:border-slate-400 dark:hover:border-white/20'}`}
          >
            {s}
          </button>
        ))}
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {filtered.map((p) => (
          <motion.article
            key={p.id}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            className="rounded-2xl border border-slate-200 dark:border-white/10 overflow-hidden bg-white dark:bg-white/5 backdrop-blur hover:border-slate-300 dark:hover:border-white/20 transition"
            onClick={() => open(p)}
          >
            <img src={p.image} alt="" className="h-40 w-full object-cover" />
            <div className="p-4 space-y-2">
              <h3 className="font-semibold">{p.title}</h3>
              <p className="text-sm text-slate-700 dark:text-foreground/80 line-clamp-3">{p.description}</p>
              <div className="flex flex-wrap gap-1 text-xs text-slate-600 dark:text-foreground/70">
                {p.stack.map(tag => (
                  <span key={tag} className="px-2 py-0.5 rounded-full bg-slate-100 dark:bg-white/10">{tag}</span>
                ))}
              </div>
              <div className="pt-2 flex gap-3 text-sm">
                <a className="text-primary hover:underline" href={p.demo} target="_blank" rel="noreferrer">Live</a>
                <a className="hover:underline" href={p.github} target="_blank" rel="noreferrer">Code</a>
              </div>
            </div>
          </motion.article>
        ))}
      </div>
      {active && (
        <div className="fixed inset-0 z-50 grid place-items-center bg-black/60 p-4" onClick={close}>
          <div className="max-w-lg w-full rounded-2xl border border-slate-200 dark:border-white/10 bg-white dark:bg-background p-5" onClick={(e) => e.stopPropagation()}>
            <img src={active.image} alt="" className="h-48 w-full object-cover rounded-xl" />
            <h3 className="mt-4 text-xl font-semibold">{active.title}</h3>
            <p className="text-slate-700 dark:text-foreground/80">{active.description}</p>
            <div className="flex flex-wrap gap-1 mt-2 text-xs text-slate-600 dark:text-foreground/70">
              {active.stack.map(tag => (
                <span key={tag} className="px-2 py-0.5 rounded-full bg-slate-100 dark:bg-white/10">{tag}</span>
              ))}
            </div>
            <div className="mt-4 flex gap-3">
              <a className="px-4 py-2 rounded-lg bg-primary text-white" href={active.demo} target="_blank" rel="noreferrer">Live Demo</a>
              <a className="px-4 py-2 rounded-lg border border-slate-200 dark:border-white/10" href={active.github} target="_blank" rel="noreferrer">GitHub</a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProjectsPage;


